import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'customer-login',
  templateUrl: 'customer-login.html',
  styleUrls: ['./header.component.less']
})
export class CustomerLoginDialogComponent {
  hide = true;
  email = new FormControl('', [Validators.required, Validators.email]);

  mode: 'login' | 'register' | 'forgot' = 'login';
  otpShow = false;
  errorMessage = '';

  constructor(private authService: AuthService) {}

  getErrorMessage(): string {
    if (this.email.hasError('required')) return 'You must enter a value';
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  login(phone: string, password: string): void {
    if (!phone || !password) {
      this.errorMessage = 'All fields are required';
      return;
    }
    this.errorMessage = '';

    this.authService.login(phone, password).subscribe((response) => {
      if (response.status === 'success') {
        this.authService.setSession(response.customer_id, response.customer_name, response.token);
        window.location.reload();
      } else {
        this.errorMessage = 'Please check phone and password';
      }
    });
  }

  forgotPwd(phone: string): void {
    if (!phone) {
      this.errorMessage = 'All fields are required';
      return;
    }
    this.errorMessage = '';

    this.authService.forgotPassword(phone).subscribe((response) => {
      if (response.status === 'success') {
        Swal.fire({
          title: 'Success',
          text: 'We have sent you an SMS with a temporary password.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {
        this.errorMessage = 'Please check phone number';
      }
    });
  }

  toggleshow(): void {
    this.mode = this.mode === 'forgot' ? 'login' : 'forgot';
  }

  toggleshow2(): void {
    this.mode = 'register';
  }

  generateOtp(mobile: string): void {
    this.authService.sendOtp(mobile).subscribe();
  }

  register(name: string, mobile: string, email: string, password: string, otpEntered: string): void {
    const phoneValid = this.authService.validatePhone(mobile);

    if (!name || !mobile || !email || !password) {
      this.errorMessage = 'All fields are required';
      return;
    }
    if (!phoneValid) {
      this.errorMessage = 'Please check your phone number';
      return;
    }

    this.authService.checkOtp(mobile, otpEntered).subscribe((isValid) => {
      if (!this.otpShow) {
        this.errorMessage = '';
        this.generateOtp(mobile);
        this.otpShow = true;
        return;
      }
      if (!isValid) {
        this.errorMessage = 'Wrong OTP';
        return;
      }

      this.errorMessage = '';
      this.authService.register(name, mobile, email, password).subscribe((response) => {
        if (response.status === 'success') {
          this.authService.setSession(response.customer_id, response.customer_name, response.token);
          window.location.reload();
        } else {
          this.errorMessage = response.message || 'Registration failed';
        }
      });
    });
  }
}
